'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { setNavigationFunction } from '@/src/utils/api-client';

/**
 * Hook to set up the navigation function for the API client
 * This allows the API client to use client-side navigation
 * when redirecting to the upgrade page after subscription errors
 */
export function useNavigationForApi() {
  const router = useRouter();

  useEffect(() => {
    // Set the navigation function using the router
    setNavigationFunction((path: string) => {
      router.push(path);
    });

    // No cleanup needed as we want the navigation function to persist
  }, [router]);

  // This hook doesn't return anything, it just sets up the navigation
  return null;
}
